module.exports = __webpack_public_path__ + "img/pdf.d3ee259a.svg";